import { Controller } from "@hotwired/stimulus"

// Modale d'ouverture du formulaire « Commander » d'un souvenir.
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event?.preventDefault()
    this.dialogTarget.classList.remove("hidden")
    this.dialogTarget.classList.add("flex")
    document.body.style.overflow = "hidden"
  }

  close(event) {
    event?.preventDefault()
    this.dialogTarget.classList.add("hidden")
    this.dialogTarget.classList.remove("flex")
    document.body.style.overflow = ""
  }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.close(event)
  }
}
